import React from 'react';
import cx from './cx';

const PADDING = { none: '', sm: 'p-3', md: 'p-4', lg: 'p-4 sm:p-5' };

/** Surface container. `interactive` adds hover/focus affordances for clickable cards. */
export function Card({ as: Component = 'div', padding = 'md', interactive = false, className, children, ...rest }) {
  return (
    <Component
      className={cx(
        'rounded-panel border border-line bg-surface text-fg shadow-card',
        PADDING[padding],
        interactive && 'transition-colors hover:border-accent/50 hover:bg-surface-2/60 focus-visible:border-accent',
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}

export function CardHeader({ title, description, actions, as: Heading = 'h2', id, className }) {
  return (
    <div className={cx('mb-3 flex items-start justify-between gap-3', className)}>
      <div className="flex min-w-0 items-start gap-2.5">
        {/* `icon` is accepted for API compatibility but no longer drawn: fewer decorative icons. */}
        <div className="min-w-0">
          <Heading id={id} className="text-sm font-semibold text-fg">{title}</Heading>
          {description && <p className="mt-0.5 text-xs text-fg-muted">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-1.5">{actions}</div>}
    </div>
  );
}

export default Card;
